export const BrandEndpoints = {
    list: '/brand/list',
    add: '/brand/add',
    edit: (id: string) => `/brand/edit/${id}`,
    remove: (id: string) => `/brand/del/${id}`,
    info: (id: string) => `/brand/${id}`,
    toggle: (id: string) => `/brand/status/${id}`,
}
